import React, { useEffect } from "react";
import "./About.css";
import resume from "../../assets/documents/Martha-Mwau-CV.pdf";
import AOS from "aos";
import "aos/dist/aos.css";

const About = () => {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 200,
      easing: "ease-in-sine",
      delay: 50,
    });
  }, []);

  return (
    <section className="about">
      <div className="about-container">
        <h2 className="about-title">Get to know Me</h2>
        <div className="about-content">
          <div className="about-text" data-aos="fade-left">
            <p className="text">
              I am a skilled and hardworking full-stack developer who is good at
              React, Ruby on Rails and API integration. I am also flexible in
              adopting new technologies and taking up challenges.
            </p>
            <p className="text">
              My passion for learning and innovation has always made me
              dedicated to delivering the best applications possible.
            </p>
            <p className="text">
              Hence with a positive attitude and dedication to self-improvement
              that comes as a result of having an optimistic mindset coupled
              with strong focus towards personal development, I strive to make
              significant contributions in the software development industry.
            </p>
            <p className="text">Let's bring ideas to life together! 💻✨</p>
            <button className="cssbuttons-io-button">
              <a href={resume} download="Martha-Mwau-CV.pdf">
                <svg
                  height="24"
                  width="24"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 0h24v24H0z" fill="none"></path>
                  <path
                    d="M1 14.5a6.496 6.496 0 0 1 3.064-5.519 8.001 8.001 0 0 1 15.872 0 6.5 6.5 0 0 1-2.936 12L7 21c-3.356-.274-6-3.078-6-6.5zm15.848 4.487a4.5 4.5 0 0 0 2.03-8.309l-.807-.503-.12-.942a6.001 6.001 0 0 0-11.903 0l-.12.942-.805.503a4.5 4.5 0 0 0 2.029 8.309l.173.013h9.35l.173-.013zM13 12h3l-4 5-4-5h3V8h2v4z"
                    fill="currentColor"
                  ></path>
                </svg>
                <span>Download CV</span>
              </a>
            </button>
          </div>
          <div className="map-content" data-aos="fade-right">
            <div className="google-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d255282.3980793229!2d36.72037524564639!3d-1.3024715131888922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f11655c311541%3A0x9dd769ac1c10b897!2sNairobi%20County!5e0!3m2!1sen!2ske!4v1707395486016!5m2!1sen!2ske"
                width="350"
                height="350"
                style={{ border: "0" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Map of Nairobi, Kenya"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
